export enum ETrackerPaymentAction {
  BUTTON_CLICK = 0,
  REDIRECT = 1,
  CARD_PAYMENT = 2,
  INIT_3D = 3,
  COMPLETE_3D = 4,
  SUCCESS = 5,
  FAILED = 6,
  TOKEN = 7,
  PAYMENT_3D_SECURE = 8,
  RESULT_AUTH_REQUIRED_3D_Y = 9,
  RESULT_AUTH_REQUIRED_3D_N = 10,
  RESPONSE_3D = 11,
  REQUEST = 12,
  INITIATE_AUTHENTICATION_REQUEST = 13,
  INITIATE_AUTHENTICATION_RESPONSE = 14,
  INITIATE_AUTHENTICATION_RESPONSE_FAILED = 15,
  CONTINUE_AUTHENTICATION_REQUEST = 16,
  CONTINUE_AUTHENTICATION_RESPONSE = 17,
  CONTINUE_AUTHENTICATION_RESPONSE_FAILED = 18,
  COMPLETE_AUTHENTICATION_REQUEST = 19,
  COMPLETE_AUTHENTICATION_RESPONSE = 20,
  COMPLETE_AUTHENTICATION_RESPONSE_FAILED = 21,
  PAYMENT_REQUEST = 22,
  PAYMENT_REQUEST_FAILED = 23,
  PAYMENT_RESPONSE = 24,
  PAYMENT_RESPONSE_FAILED = 25,
  SCHEMA_REFERENCE_FAILED = 26,
  INITIATE = 27,
  INITIATE_FAILED = 28,
  AUTHORIZE = 29,
  AUTHORIZE_FAILED = 30,
  TY_PAGE = 31,
  DETAIL = 32,
  REDIRECT_RESULT = 33,
  CHECK_OUT_DATA = 34,
  IDEAL_PAYMENT = 35,
  INIT_IDEAL = 36,
  BLIK_PAYMENT = 37,
  INIT_BLIK = 38,
  REPAY = 39,
  PAYMENT_NO_3D_SECURE = 40,
  RESULT_AUTH_REQUIRED_3D__Y = 41,
  RESULT_AUTH_REQUIRED_3D__N = 42,
  RESULT_AUTH_REQUIRED_3D_U_N_ERROR = 43,
  MBWAY_PAYMENT = 44,
  INIT_MBWAY = 45,
  CREATE_SESSION = 46,
}
